import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const WalkthroughObservationLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    wlkDetails: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.user-summary.wlk',
        url: '/wlk'
    },
    wlkDetails: {
        name: 'authenticated.user-summary.wlk.details',
        url: '/details/:userId/:observationId',
    }
},
() => import('src/app/observations/walkthrough/walkthrough.module')
      .then((result: { WalkthroughModule: any }) => result.WalkthroughModule));